// Generated by ts-to-zod
import { z } from 'zod'

export const iPlaceZodSchema = z.object({
  name: z.string(),
  address: z.string(),
  image_url: z.string().optional(),
  url: z.string().optional(),
  price: z
    .string()
    .regex(/^\$+$|^\£+$/) // only $ or £
    .or(z.number())
    .transform(val => {
      if (typeof val === 'string') {
        return val.length // number of $
      }
      return val
    })
    .optional(),
})

export type IPlace = z.infer<typeof iPlaceZodSchema>
